import * as c from '../../constants/auth';

export const defaultState = {
  studentId: '',
  studentIdNumber: -1,
  groupId: '',
  groupName: '',
  alias: '',
  authenticated: false,
  loading: false,
  error: {
    code: 0,
    message: '',
  },
};

const auth = (state = defaultState, action) => {
  switch (action.type) {
    case c.AUTH_LOGIN_START:
      return { ...state, loading: true, error: defaultState.error };
    case c.AUTH_LOGIN_SUCCESS:
      return { ...state, loading: false, authenticated: true };
    case c.AUTH_LOGIN_FAILURE:
      return {
        ...state,
        loading: false,
        authenticated: false,
        error: action.error,
      };
    case c.AUTH_LOGOUT_FAILURE:
    case c.AUTH_LOGOUT_SUCCESS:
      return {
        ...state,
        loading: false,
        authenticated: false,
      };
    case c.AUTH_LOGOUT_FAILURE:
      return {
        ...state,
        loading: false,
        error: {
          code: 500,
          message:
            'There was an error logging out, please close all browser windows for security',
        },
      };
    case c.AUTH_SET_STUDENT_INFO:
      return {
        ...state,
        studentIdNumber: action.studentIdNumber,
        studentId: action.studentId,
        groupId: action.groupId,
        groupName: action.groupName,
        alias: action.alias,
        isTeacher: action.isTeacher,
      };
    case c.AUTH_SET_AUTHENTICATED:
      return {
        ...state,
        authenticated: action.authenticated === true,
      };
    default:
      return state;
  }
};

export default auth;
